$(document).ready(function() {
    $("#user-notifications-button").click(function(){

        $(this).find('.counter').hide();
        $('#user-notifications-button').removeClass('active');

        $.ajax(
            {
                url: $('#user-notifications-button').data('mark-as-read-url'),
            data: {
            "_token": $('meta[name="csrf-token"]').attr('content'),
        },
        success: function (data) {
            // console.log(data);
            status = data.status;
            // if(status){
            //     console.log("All user notifications marked as read!");
            // } else {
            //     console.log("All user notifications marked as read!");
            // }
        },
        error: function (data, xhr, status, error) {
            console.log('Error:', data);
            console.log('Error:', data.statusText);
        },
    });
    });
})


// WEBPACK FOOTER //
// ./resources/assets/themes/default/js/user-notifications.js